import React from 'react';

const AnalyticsCount = () => {
    return (
        <>
            <div className='row g-3'>
                <div className='col-xl-6 col-sm-12'>
                    {/* FACEBOOK METRICS */}
                    <div
                        className='metrics'
                        style={{ borderTop: '5px solid #217BEE' }}>
                        <div className='metrics-body'>
                            <div className='metric'>
                                <p className='name'>Reach</p>
                                <h5 className='count'>12</h5>
                            </div>
                            <div className='metric'>
                                <p className='name'>Engagement</p>
                                <h5 className='count'>320</h5>
                            </div>
                            <div className='metric'>
                                <p className='name'>Impressions</p>
                                <h5 className='count'>1332</h5>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='col-xl-6 col-sm-12'>
                    {/* INSTAGRAM METRICS */}
                    <div
                        className='metrics'
                        style={{ borderTop: '5px solid #E4405F' }}>
                        <div className='metrics-body'>
                            <div className='metric'>
                                <p className='name'>Reach</p>
                                <h5 className='count'>12</h5>
                            </div>
                            <div className='metric'>
                                <p className='name'>Engagement</p>
                                <h5 className='count'>320</h5>
                            </div>
                            <div className='metric'>
                                <p className='name'>Impressions</p>
                                <h5 className='count'>1332</h5>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='col-xl-6 col-sm-12'>
                    {/* LINKEDIN METRICS */}
                    <div
                        className='metrics'
                        style={{ borderTop: '5px solid #0A66C2' }}>
                        <div className='metrics-body'>
                            <div className='metric'>
                                <p className='name'>Reach</p>
                                <h5 className='count'>12</h5>
                            </div>
                            <div className='metric'>
                                <p className='name'>Engagement</p>
                                <h5 className='count'>320</h5>
                            </div>
                            <div className='metric'>
                                <p className='name'>Impressions</p>
                                <h5 className='count'>1332</h5>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='col-xl-6 col-sm-12'>
                    {/* TWITTER METRICS */}
                    <div
                        className='metrics'
                        style={{ borderTop: '5px solid #1DA1F2' }}>
                        <div className='metrics-body'>
                            <div className='metric'>
                                <p className='name'>Reach</p>
                                <h5 className='count'>12</h5>
                            </div>
                            <div className='metric'>
                                <p className='name'>Engagement</p>
                                <h5 className='count'>320</h5>
                            </div>
                            <div className='metric'>
                                <p className='name'>Impressions</p>
                                <h5 className='count'>1332</h5>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default AnalyticsCount;
